import { render } from "./CategoryItem.vue?vue&type=template&id=3bf0cd21&scoped=true"
import script from "./CategoryItem.vue?vue&type=script&lang=js"
export * from "./CategoryItem.vue?vue&type=script&lang=js"

import "./CategoryItem.vue?vue&type=style&index=0&id=3bf0cd21&scoped=true&lang=css"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf0cd21"]])

export default __exports__